import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-grid-cars-controls__wrap" }
const _hoisted_2 = { class: "o-container -full" }
const _hoisted_3 = { class: "c-grid-cars-controls" }
const _hoisted_4 = { class: "c-grid-cars-controls__left" }
const _hoisted_5 = { class: "c-grid-cars-filter-closed" }
const _hoisted_6 = { class: "c-grid-cars-filter__select" }
const _hoisted_7 = { class: "o-fake-select__wrap" }
const _hoisted_8 = { class: "o-select__wrap" }
const _hoisted_9 = { class: "o-fake-select" }
const _hoisted_10 = { class: "o-fake-select__label" }
const _hoisted_11 = { class: "o-fake-select__options" }
const _hoisted_12 = { class: "c-grid-cars-filter-open" }
const _hoisted_13 = { class: "c-grid-cars-filter__select -hidden-desktop" }
const _hoisted_14 = { class: "o-fake-select__wrap" }
const _hoisted_15 = { class: "o-select__wrap" }
const _hoisted_16 = { class: "o-fake-select" }
const _hoisted_17 = { class: "o-fake-select__label" }
const _hoisted_18 = { class: "o-fake-select__options" }
const _hoisted_19 = { class: "c-grid-cars-controls__right" }
const _hoisted_20 = { class: "c-grid-cars-controls__filters -units" }
const _hoisted_21 = { class: "c-grid-cars-controls__keywords" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "o-button-filters-toggle",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.$root.sidebarActive = !_ctx.$root.sidebarActive))
            }, [
              _createVNode(_component_svgIco, { icon: "cars-filters" }),
              _cache[15] || (_cache[15] = _createTextVNode(" Filtrer "))
            ]),
            _createCommentVNode(" <div class=\"c-grid-cars-controls__list\">\n                            <button v-for=\"item in $root.filters.inventory\" :key=\"item.value\"\n                                class=\"o-button-cars-control\" :class=\"{'is-active': item.selected}\"\n                                @click=\"item.selected = !item.selected\">\n                                {{ item.label }}\n                            </button>\n                        </div> "),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(["c-grid-cars-filter-order o-button -button-unstyled", {'is-reverse': _ctx.$root.rev}]),
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$root.rev = !_ctx.$root.rev))
              }, [
                _createVNode(_component_svgIco, { icon: "cars-orderby" }),
                _cache[16] || (_cache[16] = _createTextVNode(" Trier par "))
              ], 2 /* CLASS */),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("select", {
                    class: "o-select -sort-by",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.$root.sort) = $event))
                  }, _cache[17] || (_cache[17] = [
                    _createElementVNode("option", {
                      "data-width": "lg",
                      value: "issitemake",
                      selected: ""
                    }, "Date d'arrivage", -1 /* HOISTED */),
                    _createElementVNode("option", {
                      "data-width": "md",
                      value: "kms"
                    }, "Kilométrage", -1 /* HOISTED */),
                    _createElementVNode("option", {
                      "data-width": "sm",
                      value: "year"
                    }, "Année", -1 /* HOISTED */),
                    _createElementVNode("option", {
                      "data-width": "xs",
                      value: "price"
                    }, "Prix", -1 /* HOISTED */)
                  ]), 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.$root.sort]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString($data.selectedLabel), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", {
                      "data-label": "Date d'arrivage",
                      class: "o-fake-select__option",
                      onClick: _cache[3] || (_cache[3] = $event => ($options.updateLabel('Date d\'arrivage', 'issitemake')))
                    }, " Date d'arrivage "),
                    _createElementVNode("div", {
                      "data-label": "Kilométrage",
                      class: "o-fake-select__option",
                      onClick: _cache[4] || (_cache[4] = $event => ($options.updateLabel('Kilométrage', 'kms')))
                    }, " Kilométrage "),
                    _createElementVNode("div", {
                      "data-label": "Année",
                      class: "o-fake-select__option",
                      onClick: _cache[5] || (_cache[5] = $event => ($options.updateLabel('Année', 'year')))
                    }, " Année "),
                    _createElementVNode("div", {
                      "data-label": "Prix",
                      class: "o-fake-select__option",
                      onClick: _cache[6] || (_cache[6] = $event => ($options.updateLabel('Prix', 'price')))
                    }, " Prix ")
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "o-button-cars-filter -close",
              onClick: _cache[7] || (_cache[7] = $event => (_ctx.$root.sidebarActive = !_ctx.$root.sidebarActive))
            }, [
              _createVNode(_component_svgIco, { icon: "close" })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: _normalizeClass(["c-grid-cars-filter-order o-button -button-unstyled", {'is-reverse': _ctx.$root.rev}]),
                onClick: _cache[8] || (_cache[8] = $event => (_ctx.$root.rev = !_ctx.$root.rev))
              }, [
                _createVNode(_component_svgIco, { icon: "cars-orderby" }),
                _cache[18] || (_cache[18] = _createTextVNode(" Trier par "))
              ], 2 /* CLASS */),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("select", {
                    class: "o-select -sort-by",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.$root.sort) = $event))
                  }, _cache[19] || (_cache[19] = [
                    _createElementVNode("option", {
                      "data-width": "lg",
                      value: "issitemake",
                      selected: ""
                    }, "Date d'arrivage", -1 /* HOISTED */),
                    _createElementVNode("option", {
                      "data-width": "md",
                      value: "kms"
                    }, "Kilométrage", -1 /* HOISTED */),
                    _createElementVNode("option", {
                      "data-width": "sm",
                      value: "year"
                    }, "Année", -1 /* HOISTED */),
                    _createElementVNode("option", {
                      "data-width": "xs",
                      value: "price"
                    }, "Prix", -1 /* HOISTED */)
                  ]), 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.$root.sort]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString($data.selectedLabel), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", {
                      "data-label": "Date d'arrivage",
                      class: "o-fake-select__option",
                      onClick: _cache[10] || (_cache[10] = $event => ($options.updateLabel('Date d\'arrivage', 'issitemake')))
                    }, " Date d'arrivage "),
                    _createElementVNode("div", {
                      "data-label": "Kilométrage",
                      class: "o-fake-select__option",
                      onClick: _cache[11] || (_cache[11] = $event => ($options.updateLabel('Kilométrage', 'kms')))
                    }, " Kilométrage "),
                    _createElementVNode("div", {
                      "data-label": "Année",
                      class: "o-fake-select__option",
                      onClick: _cache[12] || (_cache[12] = $event => ($options.updateLabel('Année', 'year')))
                    }, " Année "),
                    _createElementVNode("div", {
                      "data-label": "Prix",
                      class: "o-fake-select__option",
                      onClick: _cache[13] || (_cache[13] = $event => ($options.updateLabel('Prix', 'price')))
                    }, " Prix ")
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$root.total) + " unités ", 1 /* TEXT */),
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$root.selectedMakes, (item) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "o-button-cars-filter",
                key: item.value
              }, [
                _createTextVNode(_toDisplayString(item.label) + " ", 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: $event => (item.selected = false)
                }, [
                  _createVNode(_component_svgIco, { icon: "close" })
                ], 8 /* PROPS */, _hoisted_22)
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$root.selectedModels, (item) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "o-button-cars-filter",
                key: item.value
              }, [
                _createTextVNode(_toDisplayString(item.label) + " ", 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: $event => (item.selected = false)
                }, [
                  _createVNode(_component_svgIco, { icon: "close" })
                ], 8 /* PROPS */, _hoisted_23)
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$root.selectedTypes, (item) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "o-button-cars-filter",
                key: item.value
              }, [
                _createTextVNode(_toDisplayString(item.label) + " ", 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: $event => (item.selected = false)
                }, [
                  _createVNode(_component_svgIco, { icon: "close" })
                ], 8 /* PROPS */, _hoisted_24)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createElementVNode("button", {
            class: "c-button-cars-filter-reset o-button",
            onClick: _cache[14] || (_cache[14] = $event => (_ctx.$root.resetFilters()))
          }, [
            _createVNode(_component_svgIco, { icon: "trash" })
          ])
        ])
      ])
    ])
  ]))
}